import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, inject } from 'Mri.Web.Common';
import * as React from 'react';
import { ActiveDisplay } from './ActiveDisplay';
import { DisplaysStore } from './DisplaysStore';
import { DisplayAdditionalStatsCard } from './StatusCards/DisplayAdditionalStatsCard';
import { DisplayContractCard } from './StatusCards/DisplayContractCard';
import { DisplayGeneralStatsCard } from './StatusCards/DisplayGeneralStatsCard';
import { DisplayMapCard } from './StatusCards/DisplayMapCard';
import { DisplayTemperaturesCard } from './StatusCards/DisplayTemperaturesCard';
import { InfiniteTouchCard } from './StatusCards/InfiniteTouchCard';

export interface IDisplayStatsCardsProps {
    readonly display: ActiveDisplay;
    readonly loading: boolean;
    readonly showMap: boolean;
}

@autoinject
@observer
export class DisplayStatsCards extends React.Component<IDisplayStatsCardsProps> {
    public render() {
        const { display, loading, showMap } = this.props;

        return (
            <>
                {showMap && (
                    <div className={this.cardClass}>
                        <DisplayMapCard display={display} loading={loading} />
                    </div>
                )}

                <div className={this.cardClass}>
                    <DisplayGeneralStatsCard display={display} statusPoll={this.statusPoll} loading={loading} />
                </div>

                <div className={this.cardClass}>
                    <DisplayTemperaturesCard display={display} statusPoll={this.statusPoll} loading={loading} />
                </div>

                <div className={this.cardClass}>
                    <DisplayAdditionalStatsCard display={display} statusPoll={this.statusPoll} loading={loading} />
                </div>
            </>
        );
    }

    @computed
    private get cardClass() {
        return 'col-md-6 mb-3 px-2';
    }

    @computed
    private get activeDisplayStatus() {
        return this.displaysStore.statuses.get(this.props.display.serialNumber);
    }

    @computed
    private get statusPoll() {
        if (this.activeDisplayStatus) return this.activeDisplayStatus.lastKnownPoll.displayStatusPoll;
    }

    @inject
    private displaysStore!: DisplaysStore;
}
